import { Component, For, Show } from "solid-js";
import { useScenarioStore } from "../stores/scenario";
import { formatSimTime } from "../types";

const EventsPanel: Component = () => {
	const [scenario, scenarioActions] = useScenarioStore();
	
	const handleAdd = () => {
		scenarioActions.addClockAnnotation();
		scenarioActions.scheduleSave();
	};


	const handleTimeChange = (
		id: string,
		field: "hour" | "minute" | "second",
		value: string,
	) => {
		const ann = scenario.clockAnnotations.find((a) => a.id === id);
		if (!ann) return;
		const num = parseInt(value, 10);
		if (isNaN(num)) return;
		scenarioActions.updateClockAnnotation(id, { time: { ...ann.time, [field]: num } });
		scenarioActions.scheduleSave();
	};

	return (
		<>
			<div class="p-3 border-b border-gray-200 bg-white">
				<h2 class="text-sm font-semibold text-gray-700 mb-2">
					Klockhändelser
				</h2>
				<p class="text-[10px] text-gray-400 mb-2">
					Tidsstyrda anteckningar visas som popup under simuleringen. De
					visas i 5 sekunder vid angiven tid.
				</p>
					<button
						class="w-full px-2 py-1.5 text-xs font-medium bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
						onClick={handleAdd}
					>
						+ Lägg till händelse
					</button>
			</div>

			<div class="flex-1 overflow-y-auto">
				<For each={scenario.clockAnnotations}>
					{(ann) => (
						<div class="border-b border-gray-200 px-3 py-2 space-y-1.5">
							<div class="flex items-center justify-between">
								<span class="text-xs font-mono text-gray-500">
									{formatSimTime(ann.time)}
								</span>
								<button
									class="text-red-400 hover:text-red-600 text-xs"
									onClick={() => {
									scenarioActions.removeClockAnnotation(ann.id);
									scenarioActions.scheduleSave();
									}}
								>
									×
								</button>
							</div>

							<div class="flex gap-1">
								<input
									type="number"
									min="0"
									max="23"
									value={ann.time.hour}
									onInput={(e) =>
										handleTimeChange(
											ann.id,
											"hour",
											e.currentTarget.value,
										)
									}
									class="w-12 px-1 py-0.5 text-xs text-center border border-gray-300 rounded"
								/>
								<span class="text-gray-400 self-center text-xs">
									:
								</span>
								<input
									type="number"
									min="0"
									max="59"
									value={String(ann.time.minute).padStart(2, '0')}
									onInput={(e) =>
										handleTimeChange(
											ann.id,
											"minute",
											e.currentTarget.value,
										)
									}
									class="w-12 px-1 py-0.5 text-xs text-center border border-gray-300 rounded"
								/>
								<span class="text-gray-400 self-center text-xs">
									:
								</span>
								<input
									type="number"
									min="0"
									max="59"
									value={String(ann.time.second).padStart(2, '0')}
									onInput={(e) =>
										handleTimeChange(
											ann.id,
											"second",
											e.currentTarget.value,
										)
									}
									class="w-12 px-1 py-0.5 text-xs text-center border border-gray-300 rounded"
								/>
							</div>

							<textarea
								value={ann.text}
								onInput={(e) => {
									scenarioActions.updateClockAnnotation(ann.id, { text: e.currentTarget.value });
									scenarioActions.scheduleSave();
								}}
								class="w-full px-2 py-1 text-xs border border-gray-300 rounded resize-none"
								rows={3}
								placeholder="Händelsebeskrivning (stöder radbrytning)..."
							/>
						</div>
					)}
				</For>

				<Show when={scenario.clockAnnotations.length === 0}>
					<div class="p-4 text-sm text-gray-400 text-center">
						Inga händelser ännu. Lägg till tidsstyrda anteckningar som visas
						under simulering.
					</div>
				</Show>
			</div>
		</>
	);
};

export default EventsPanel;
